import Model from './Model'
import { TIMEZONE_OFFSET } from '@/configs/config'

export default class Task extends Model {

  get attributes () {
    return [
      'id',
      'category',
      'title',
      'body',
      'status',
      'lock',
      'object_id',
      'out',
      'progress',
      'progress_detailed'
    ]
  }

  constructor (data) {
    super(data)

    // 23.12.2019T12:14:15
    const timeStartAt = (data.time_start || '').match(/(\d+)\.(\d+)\.(\d+)T(.+)/)
    if (timeStartAt && timeStartAt.length === 5) {
      this.time_start = makeDate(timeStartAt)
    }

    const timeFinishAt = (data.time_finish || '').match(/(\d+)\.(\d+)\.(\d+)T(.+)/)
    if (timeFinishAt && timeFinishAt.length === 5) {
      this.time_finish = makeDate(timeFinishAt)
    }

    this.progress_detailed = this.__data.progress_detailed
    this.object_id = this.__data.object_id
  }
}

const makeDate = (dateTime) => {
  const [, day, month, year, time] = dateTime
  return new Date(`${year}-${month}-${day}T${time}${TIMEZONE_OFFSET}`)
}
